import styled from 'styled-components';

type MarginBottomProps = {
  $value?: string;
}
export const MarginBottom = styled.div<MarginBottomProps>`
	margin-bottom: ${props => props.$value || '16px'};
`;

export const AdditionalContent = styled.div`
	padding: 8px 12px;
	width: 80%;
`;
